import React from 'react';
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  IconButton,
  Stack,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

export default function RouteFields({
  values,
  errors,
  duplicate,
  onChange,
  onRemove,
  edit,
}) {
  const handleChange = (name, value) => {
    onChange(name, value);
  };

  return (
    <Stack direction='row' spacing={2} alignItems='flex-start'>
      <Grid container spacing={2} sx={{ flexGrow: 1 }}>
        <Grid size={{ xs: 12, sm: 2 }}>
          <FormControl fullWidth>
            <InputLabel id={`verb-${values.verb}-label`}>HTTP Verb</InputLabel>
            <Select
              labelId={`verb-${values.verb}-label`}
              id={`verb-${values.verb}`}
              value={values.verb || 'POST'}
              label='HTTP Verb'
              disabled
            >
              <MenuItem value='POST'>POST</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <TextField
            label='Path'
            id='path'
            name='path'
            value={values.path || ''}
            onChange={(e) => handleChange('path', e.target.value)}
            placeholder='/predict'
            error={Boolean(errors.path_error || duplicate)}
            helperText={
              errors.path_error
                ? 'Invalid Route'
                : duplicate
                ? 'Duplicate Route'
                : ''
            }
            variant='outlined'
            fullWidth
            disabled={edit}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <TextField
            label='File Name'
            id='file'
            name='file'
            value={values.file || ''}
            onChange={(e) => handleChange('file', e.target.value)}
            placeholder='predict.py'
            error={Boolean(errors.file_error)}
            helperText={errors.file_error ? 'Invalid File Path' : ''}
            variant='outlined'
            fullWidth
            disabled={edit}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 2 }}>
          <TextField
            label='Function Name'
            id='function'
            name='function'
            value={values.function || ''}
            onChange={(e) => handleChange('function', e.target.value)}
            placeholder='get_prediction'
            error={Boolean(errors.function_error)}
            helperText={errors.function_error ? 'Invalid Function Name' : ''}
            variant='outlined'
            fullWidth
            disabled={edit}
          />
        </Grid>
      </Grid>
      <IconButton onClick={onRemove} color='error' sx={{ mt: 1 }}>
        <CloseIcon />
      </IconButton>
    </Stack>
  );
}

